module.exports = __webpack_public_path__ + "img/icon-locked.a29b0225.svg";